<template>
  <div id="app">
   
          <router-view></router-view>
          <Menu> </Menu>
    
    </div>

  
</template>

<script>
import Menu from "@/components/Nav.vue";


export default {
  name: "App",
  components: {
    Menu
  },

  

};
</script>

<style>
   
</style>
